import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import TimeUp from "../../assets/img/dropoff-timer.svg";
import TimeLeft from "../../assets/img/dropoff-timer.svg";
import User from '../../services/user.service';
import Numbers from '../../services/numbers.service';
import moment from "moment";
import Storage from '../../services/storage.service';
import Summaries from '../../services/summaries.service';
import StmSummary from '../shared/storefront-summary';
import storefront from '../../services/storefront.service';
import StorefrontTitle from '../shared/storefront-title.component';
import DropOffModalSkeleton from '../skeleton/dropOffModal';
import NumberIcon from "../../assets/img/number-icon.png";
import FirebaseAnalytics from '../../services/analytics.service';
import CONSTANTS from '../../services/constants.service';
import checkModule from '../shared/checkModule';
import SpinnerTimeLoader from '../shared/timeLoading';

const subscriptions = [];
const DropOff = (props) => {
  const [loading, setLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [numberExpiry, setNumberExpiry] = useState(0);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [selectedVaniity, setSelectedVaniity] = useState(null);
  const [bookingStatus, setBookingStatus] = useState(null);
  const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
  const [actionLoading, setActionLoading] = useState(false);
  const { isDropOffKw, isDropOffKsa } = checkModule

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe(data => {
        setTranslationsKeys(data);
      })
    )

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    }

  }, []);

  useEffect(() => {
    if (isDropOffKsa) {
      getSummaryDetail();
      getNumberDetailNew();
    } else {
      let mnpNumber = Storage.get("mnpNumber", true);
      if(mnpNumber){
        setLoading(true);
        checkNumberStatusAndReregister(mnpNumber, false);
      } else {
        getSummaryDetail();
      }
    }
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const getNumberDetailNew = async () => {
    setLoading(true)
    let numberCheck = Storage.get("number", true) || await getNumberFromSummary();
    setLoading(true);
    Numbers.getNumberStats()
      .then(response => {
        setLoading(false);
        let data = (response.data.numbers.find((item) => item.MSISDN === (numberCheck)));
        if (data.MSISDN) {
          setSelectedNumber(data.MSISDN);
          setSelectedVaniity(data.VanityLevelId);
          setNumberExpiry(data.ExpiryDate);
          // setBookingStatus(5);
          setBookingStatus(data.BookingStatus);
          // setStepperVal("1");
          // if (data.BookingStatus === 5) {

          // }
        } else {
          setLoading(false);
        }
      })
      .catch(error => {
        setLoading(false);
      })
  }
  const getNumberFromSummary = async () => {
    setSummaryLoading(true);
    let MSISDN = null;
    await Summaries.getSummary()
      .then((res) => {
        if (res?.data?.number_details) {
          if (res.data.number_details.MSISDN) {
            Storage.set("number", res.data.number_details.MSISDN, true);
            setSelectedNumber(res.data.number_details.MSISDN);
            setSelectedVaniity(res.data.number_details.VanityLevelID);
            MSISDN = res.data.number_details.MSISDN;
            setSummaryLoading(false);
          }
        }
      })
      .catch(() => {
        setSummaryLoading(false);
      })
    return MSISDN;
  }

  const checkNumberStatusAndReregister = (number, register) => {
    setLoading(true);
    Numbers.getNumberStats()
      .then(res => {
        let data = (res.data.numbers.find((item) => item.MSISDN === (number || Storage.get("number", true) || Storage.get("mnpNumber", true))));
        setNumberExpiry(data.ExpiryDate);
        setSelectedVaniity(data.VanityLevelId);
        if (register && data.BookingStatus === 5) {
          Numbers.postNumber(selectedNumber || Storage.get("number", true))
            .then((response) => {
              props.closeDropOffScreen();
              localStorage.removeItem("TabSwitched");
              sessionStorage.removeItem("TabSwitchedBack");
              User.fetchFlowStatus();
            })
            .catch(error => {
              console.log("Error", error);
            })
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Catch issue:', error);
        setLoading(false);
      })
  }
  const handleRequestAgain = async () => {
    FirebaseAnalytics.button_clicked(CONSTANTS.DROP_OFF_SCREEN, "stm_number_status_request_again")
    setLoading(true);
    // Case: Number has expired. Now trying to register same number again.
    let numberCheck = Storage.get("number", true) || await getNumberFromSummary()
    Numbers.postNumber(numberCheck)
      .then((response) => {
        if (response) {
          User.fetchFlowStatus()
            .then((res) => {
              localStorage.removeItem("TabSwitched");
              sessionStorage.removeItem("TabSwitchedBack");
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
            });
          setLoading(false);
        }
      })
      .catch(error => {
        // Error Logged
      })
  }

  const getSummaryDetail = () => {
    setLoading(true)
    Summaries.getSummary()
      .then(response => {
        if (response && response.data && response.data.number_details && response.data.number_details.MSISDN) {
          if (response.data.number_details.MSISDN) {
            setSelectedNumber(response.data.number_details.MSISDN);
            Storage.set("number", response.data.number_details.MSISDN, true)
          }
          checkNumberStatusAndReregister(response.data.number_details.MSISDN, false);
        } else {
          setLoading(false);
        }
      })
      .catch(error => {
        setLoading(false);
        console.error('verification catch issue:', error);
      })
  }

  const continueHandling = () => {
    FirebaseAnalytics.button_clicked(CONSTANTS.DROP_OFF_SCREEN, "kw_buttons_continue_lwr")
    setActionLoading(true);
    Numbers.confirmRandomNumber()
      .then(() => {
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
        props.closeDropOffScreen();
        User.fetchFlowStatus().then(() => {
          setActionLoading(false);
        }).catch(() => {
          setActionLoading(false);
        })
      })
      .catch(() => {
        setActionLoading(false);
      })
  }

  const chooseAnotherNumber = () => {
    FirebaseAnalytics.button_clicked(CONSTANTS.DROP_OFF_SCREEN, "ob_drop_off_choose_another_number")
    setActionLoading(true);
    User.getFlowStatus().then(
      res => {
        if (res.data.flow_status_flags.IsMnp === true) {
          Numbers.mnpCancel(selectedNumber.trim())
            .then(response => {
              User.fetchFlowStatus(7)
                .then((res) => {
                  if (!isDropOffKsa) {   
                    Storage.clear("mnpNumber");
                    Storage.clear("mnpDetails");
                    Storage.clear("mnpOTPExpiry");
                    Storage.clear("mnpOTPValue");
                    Storage.clear("mnpOTPGenerated");
                    Storage.clear("eligible_update_mnp");
                  }
                  Storage.clear("choose_random_number")
                  Storage.clear("random_number")
                  Storage.clear("choose_mnp");
                  localStorage.removeItem("TabSwitched");
                  sessionStorage.removeItem("TabSwitchedBack");
                  setActionLoading(false);
                })
                .catch((error) => { setActionLoading(false); });
            })
            .catch(error => { setActionLoading(false); })


        } else {
          Numbers.cancel(selectedNumber.trim())
            .then(response => {
              User.fetchFlowStatus(7)
                .then((res) => {
                  Storage.clear("choose_random_number")
                  Storage.clear("random_number")
                  Storage.clear("choose_mnp");
                  localStorage.removeItem("TabSwitched");
                  sessionStorage.removeItem("TabSwitchedBack");
                  setActionLoading(false);
                })
                .catch((error) => { setActionLoading(false); });
            })
            .catch(error => { setActionLoading(false); })
        }
      })
      .catch(error => { setActionLoading(false) });
  }

  const getExpiryTimeToShow = () => {
    let startTime = moment(numberExpiry).utc();
    let seconds = moment(startTime).diff(moment(), 'seconds');
    let datH = moment.duration(seconds, "seconds").hours();
    let datM = moment.duration(seconds, "seconds").minutes();
    if (datH > 0) {
      if (datH > 1) {
        return `${moment(startTime).diff(moment(), 'hours')} ${translationKeys["ob_drop_off_hours_until_we"]}`;
      } else {
        if (Translations.activeLang === "ar") {
          return `${translationKeys["ob_drop_off_hour_until_we"]}`;
        } else {
          return `${moment(startTime).diff(moment(), 'hours')} ${translationKeys["ob_drop_off_hour_until_we"]}`;
        }
      }
    } else if (datM > 0) {
      if (datM > 1) {
        return `${moment(startTime).diff(moment(), 'minutes')} ${translationKeys["ob_drop_off_minutes_until_we"]}`;
      } else {
        return `${moment(startTime).diff(moment(), 'minutes')} ${translationKeys["ob_drop_off_minute_until_we"]}`;
      }
    } else {
      return `${moment(startTime).diff(moment(), 'seconds')} ${translationKeys["ob_drop_off_seconds_until_we"]}`;
    }
  }

  const getExpiryTime = () => {
    let startTime = moment(numberExpiry).utc();
    return moment(startTime).diff(moment(), 'seconds');
  }


  const getColorFromVanity = (Vanitylevel) => {
    // GET VANITY COLOR
    let style = {};
    let theme = Storage.get("theme", true);
    let vanity_theme = isDropOffKw ? "stf_vanity_" : "vanity_level";
    let theme_parsed = JSON.parse(theme);
    if (theme && vanity_theme && theme_parsed) {
      let style_value_comp = vanity_theme + Vanitylevel;
      if (style_value_comp) {
        let style_value = theme_parsed[style_value_comp];
        style["color"] = style_value;
      }
    }
    return style;
  };


  return (
    <React.Fragment>
      {(actionLoading || summaryLoading) ? <SpinnerTimeLoader /> : 
      <>
        {Storage.get("number", true) ? (
          <div className="storefront-two-col-pg">
            <div className="container-ob-single drop-off">
              {getExpiryTime() < 0 ? (
                // Number Released Scenario
                <>
                  <img src={TimeUp} alt="" />
                  <StorefrontTitle
                    title={translationKeys["ob_drop_off_timeup"]}
                    desc={translationKeys["ob_drop_off_timeup_msg"]}
                  />
                  {loading ? (
                    <DropOffModalSkeleton />
                  ) : (
                    <>
                      {!!selectedNumber &&
                        <div className="number-stm-wrapper">
                          <div className="number-selection-container stm-number-card-btn drop-off-number-container">
                            <div className="details-container">
                              <img
                                className="badge-section"
                                src={storefront.getPoImage(
                                  "stf_vanity_img",
                                  `stf_vanity_${selectedVaniity}`
                                ) || NumberIcon}
                                alt=""
                              />
                              <div className="details-section">

                                <div className="number-section-dropoff">
                                  {Numbers.get_number_pieces(
                                    selectedNumber,
                                    selectedVaniity,
                                    null,
                                    getColorFromVanity(selectedVaniity)
                                  )}
                                </div>
                                <p
                                  className="number-text"
                                  style={getColorFromVanity(selectedVaniity)}
                                >
                                  {
                                    translationKeys[
                                    `general_vanity_name_${selectedVaniity}number`
                                    ]
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>}
                      {isDropOffKw ? 
                      <div className="drop-off-button-container">
                        <button
                          className="continue-button red"
                          onClick={() => {
                            checkNumberStatusAndReregister(
                              selectedNumber || Storage.get("number", true) || Storage.get("mnpNumber", true),
                              true
                            );
                          }}
                        >
                          {translationKeys["ob_drop_off_request_again"]}
                        </button>
                        <div
                          className="continue-button light-red center-text-button"
                          onClick={chooseAnotherNumber}
                        >
                          {translationKeys["ob_drop_off_choose_another_number"]}
                        </div>
                      </div> : null}
                    </>
                  )}
                </>
              ) : (
                <>
                  <img src={TimeLeft} alt="" />
                  <div className="main-banner-text-kw banner-remove-margin">
                    <StorefrontTitle
                      title={getExpiryTime() > 0 && getExpiryTimeToShow()}
                      desc={translationKeys["ob_drop_off_timeleft_msg"]}
                    />
                  </div>
                  {loading ? (
                    <DropOffModalSkeleton />
                  ) : (
                    <>
                      {!!selectedNumber &&
                        <div className="number-stm-wrapper">
                          <div className="number-selection-container stm-number-card-btn drop-off-number-container">
                            <div className="details-container">
                              <img
                                className="badge-section"
                                src={storefront.getPoImage(
                                  "stf_vanity_img",
                                  `stf_vanity_${selectedVaniity}`
                                ) || NumberIcon}
                                alt=""
                              />
                                  
                              <div className="details-section">
                                <div className="number-section-dropoff">
                                  {Numbers.get_number_pieces(
                                    selectedNumber,
                                    selectedVaniity,
                                    null,
                                    getColorFromVanity(selectedVaniity)
                                  )}
                                </div>
                                <p
                                  className="number-text"
                                  style={getColorFromVanity(selectedVaniity)}
                                >
                                  {
                                    translationKeys[
                                    `general_vanity_name_${selectedVaniity}number`
                                    ]
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {isDropOffKw ? <div className="drop-off-button-container">
                        <button
                          className="continue-button red"
                          onClick={continueHandling}
                        >
                          {translationKeys["kw_buttons_continue_lwr"]}
                        </button>
                        <button
                          className="continue-button light-red"
                          onClick={chooseAnotherNumber}
                        >
                          {translationKeys["ob_drop_off_choose_another_number"]}
                        </button>
                      </div> : null}
                    </>
                  )}
                </>
              )}
              {!loading && isDropOffKsa ? <div className="drop-off-button-container">
                {bookingStatus === 5 &&
                  <button
                    className="continue-button red"
                    onClick={() => handleRequestAgain()}
                  >
                    {translationKeys["stm_number_status_request_again"]}
                  </button>
                }

                {bookingStatus === 1 && getExpiryTime() > 0 &&
                  <button
                    className="continue-button red"
                    onClick={() => continueHandling()}
                  >
                    {translationKeys["stm_number_status_continue"]}
                  </button>
                }

                {bookingStatus === 1 && getExpiryTime() < 0 &&
                  <button
                    className="continue-button red"
                    onClick={() => continueHandling()}
                  >
                    {translationKeys["stm_number_status_request_again"]}
                  </button>
                }

                {bookingStatus &&
                  <button
                    className="continue-button light-red"
                    onClick={() => chooseAnotherNumber()}
                  >
                    {translationKeys["stm_number_status_choose_no"]}
                  </button>
                }
              </div> : null}
            </div>
            <StmSummary />
          </div>
        ) : (
          <div className="container-ob-single drop-off">
            <DropOffModalSkeleton />
          </div>
        )}
      </>}
    </React.Fragment>
  );
}

export default DropOff;